<template>
  <!--
    Kontener zakładek predefiniowanych filtrów:
    - 'preselect-tabs': główny div opakowujący
    - dynamiczna klasa 'step' do stylizacji w zależności od kroku
  -->
  <div class="preselect-tabs">
    <!--
      Nawigacja jako pigułki (pills):
      - flex-column dla układu pionowego na małych ekranach
      - flex-sm-row dla układu poziomego na większych ekranach
    -->
    <nav class="nav nav-pills flex-column flex-sm-row">
      <!--
        Generowanie każdej zakładki:
        - 'store.preselectTabs': tablica identyfikatorów lub kluczy tłumaczeń
        - :class aktywna dla bieżąco wybranej zakładki
        - @click wywołuje zmianę filtra
      -->
      <div
        class="flex-sm-fill text-sm-center nav-link"
        :class="[{ active: isActive(index) }]"
        v-for="(item, index) in store.preselectTabs"
        :key="index"
        @click="setFilters(index)"
      >
        <!-- Wyświetlenie przetłumacowanej nazwy zakładki -->
        {{ t(item) }}
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "PreselectTabs", // Nazwa komponentu w Vue DevTools
  props: {
    // Store Pinia z danymi filtrów predefiniowanych
    store: { required: true },
  },
  methods: {
    /**
     * Ustawia aktywną zakładkę predefiniowaną
     * @param {number} index - indeks wybranej zakładki
     */
    setFilters(index) {
      this.store.setPreselectTab(index);
    },
    /**
     * Sprawdza, czy dana zakładka jest aktywna
     * @param {number} id - indeks zakładki
     * @returns {boolean}
     */
    isActive(id) {
      return this.store.preselectActiveTab === id;
    },
  },
};
</script>

<style scoped>
/*
  Styl głównego kontenera:
  - pełna szerokość, minimalna wysokość równoważąca zawartość
*/
.preselect-tabs {
  width: 100%;
  min-height: 40px;
}

/*
  Pojedyncza zakładka:
  - domyślny kolor tekstu i kursor wskazówki
  - obramowanie po prawej stronie (wyjątek dla ostatniej)
  - odstęp wewnętrzny (padding)
*/
.nav-link {
  color: #373737;
  cursor: pointer;
  border-right: 1px solid #bfbfbf;
  padding: 3px 15px;
  margin: 5px 0;
  border-radius: 0;
}

/* Brak obramowania po prawej dla ostatniej zakładki */
.nav-link:last-child {
  border-right: 0;
}

/* Styl po najechaniu myszką */
.nav-link:hover {
  color: black;
  text-decoration: underline;
}

/* Styl aktywnej zakładki:
   - pogrubienie, podkreślenie, brak tła */
.nav-link.active {
  color: #373737;
  text-decoration: underline;
  font-weight: bold;
  background: none;
}
</style>